
export default {
  name: 'ContentCard',
  components: {
    CardTitle: () => import(/* webpackChunkName: "ContentCardTitle" */ './ContentCardTitle'),
    CardParagraph: () => import(/* webpackChunkName: "ContentCardParagraph" */ './ContentCardParagraph'),
    CardInfo: () => import(/* webpackChunkName: "ContentCardInfo" */ './ContentCardInfo'),
    CardLink: () => import(/* webpackChunkName: "ContentCardLink" */ './ContentCardLink'),
    CardList: () => import(/* webpackChunkName: "ContentCardList" */ './ContentCardList'),
    ReadMore: () => import(/* webpackChunkName: "ReadMore" */ '../ui/ReadMore'),
    Accordion: () => import(/* webpackChunkName: "AccordionSingle" */ '~/components/ui/AccordionSingle')
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    contents: {
      required: true,
      default: []
    },
    title: {
      required: false,
      default: '',
      type: String
    },
    openedInitially: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ cardTitle: '' }),
  created () {
    this.cardTitle = this.contents[0] ? this.contents[0].value : this.title
  },
  methods: {
    getContentComponentName (type) {
      switch (type) {
        case 'title': return 'CardTitle'
        case 'paragraph': return 'CardParagraph'
        case 'info': return 'CardInfo'
        case 'link': return 'CardLink'
        case 'list': return 'CardList'
      }
    }
  }
}
